import React from "react";

const TermsService = () => {
  return (
    <div className="container mx-auto pl-16 pr-72 py-6 bg-gray-50">
      {/* Header Section */}
      <div className="text-2xl sm:text-4xl lg:text-4xl text-gray-900 mb-6 font-bold">
        Minglee Terms of Service
      </div>
      <p>
        Please review the updated Terms carefully. Minglee builds technologies
        and services that enable people to connect with each other, build
        communities, and grow businesses. These Terms govern your use of
        Minglee, except where expressly stated that separate terms apply. These
        products are provided to you by Minglee Platforms, Inc.
      </p>

      {/* Usage of Minglee Products */}
      <div className="text-2xl text-custom-red font-semibold my-8 mb-3">
        1. Usage of Minglee Products
      </div>
      <p>
        Our products are free to use unless specified otherwise. Instead,
        businesses, organizations, and individuals compensate us to display ads
        for their products and services. By using Minglee Products, you consent
        to the display of personalized advertisements that may interest you
        based on your personal data.
      </p>

      {/* Privacy and Data */}
      <div className="text-2xl text-custom-red font-semibold my-8 mb-3">
        2. Privacy and Data
      </div>
      <p>
        We commit to not selling your personal data to advertisers. We also do
        not share identifiable personal information like your name or email
        without explicit permission. Instead, advertisers provide parameters for
        their target audience, and we display their ads accordingly. Our
        detailed data usage for ad personalization is outlined in our Privacy
        Policy. You can adjust your privacy settings within Minglee Products at
        any time.
      </p>

      {/* Services Provided */}
      <div className="text-2xl text-custom-red font-semibold my-8 mb-3">
        3. Services Provided
      </div>
      <div className="flex items-center">
        <div className="w-1 bg-custom-red h-6 mr-3 "></div>
        <div className="font-bold py-3">Personalized Experience</div>
      </div>
      <p className="pl-3">
        We tailor your experience on Minglee by using data from your activities,
        settings, and interactions.
      </p>
      <div className="flex items-center">
        <div className="w-1 bg-custom-red h-6 mr-3"></div>
        <div className="font-bold py-3">Connection Tools</div>
      </div>
      <p className="pl-3">
        Minglee helps you connect with people, groups, and organizations. We
        suggest potential connections based on your data to enhance your
        networking.
      </p>
      <div className="flex items-center">
        <div className="w-1 bg-custom-red h-6 mr-3"></div>
        <div className="font-bold  py-3">Content Sharing and Communication</div>
      </div>
      <p className="pl-3">
        Minglee offers various ways to share and communicate, such as status
        updates, media uploads, and real-time communication features.
      </p>
      <div className="flex items-center">
        <div className="w-1 bg-custom-red h-6 mr-3"></div>
        <div className="font-bold py-3">Discoverability</div>
      </div>
      <p className="pl-3">
        Through features like friend locator, you can find friends nearby using
        your location data, enhancing your ability to connect with others in
        your vicinity.
      </p>
      <div className="flex items-center">
        <div className="w-1 bg-custom-red h-6 mr-3"></div>
        <div className="font-bold py-3">Interactive Notifications</div>
      </div>
      <p className="pl-3">
        Receive notifications for comments, likes, friend requests, and other
        interactions to stay engaged with your community.
      </p>

      {/* Safety and Security */}
      <div className="flex items-center mt-5">
        <div className="w-1 bg-custom-red h-6 mr-3"></div>
        <div className="font-bold py-3">Safety and Security</div>
      </div>
      <p className="pl-3">
        We are dedicated to the safety and security of our users and employ
        advanced measures to protect user data and ensure the integrity of our
        services.
      </p>

      {/* Content Ownership and License */}
      <div className="flex items-center">
        <div className="w-1 bg-custom-red h-6 mr-3"></div>
        <div className="font-bold py-3">Content Ownership and License</div>
      </div>
      <p className="pl-3">
        You retain ownership of the intellectual property you create. However,
        by sharing content on Minglee, you grant us a non-exclusive,
        transferable, sub-licensable, royalty-free, worldwide license to use
        your content as part of our operations. This license extends to hosting,
        using, distributing, modifying, and creating derivative works from your
        content. This license ends when your content is deleted from our
        systems.
      </p>

      {/* Commitments to Minglee */}
      <div className="text-2xl text-custom-red font-semibold my-8 mb-3">
        4. Commitments to Minglee
      </div>
      <div className="flex items-center">
        <div className="w-1 bg-custom-red h-6 mr-3"></div>
        <div className="font-bold py-3">Account Integrity</div>
      </div>
      <p className="pl-3">
        Use your real name and provide accurate information about yourself.
      </p>
      <div className="flex items-center">
        <div className="w-1 bg-custom-red h-6 mr-3"></div>
        <div className="font-bold py-3">Account Security</div>
      </div>
      <p className="pl-3">
        Maintain the security of your account by not sharing your password and
        not transferring your account without permission.
      </p>
      <div className="flex items-center">
        <div className="w-1 bg-custom-red h-6 mr-3"></div>
        <div className="font-bold py-3">Compliance</div>
      </div>
      <p className="pl-3">
        You must not use Minglee to engage in illegal, misleading, or fraudulent
        activities or share content you do not have the rights to share.
      </p>
      <div className="flex items-center">
        <div className="w-1 bg-custom-red h-6 mr-3"></div>
        <div className="font-bold py-3">Using Our Intellectual Property</div>
      </div>
      <p className="pl-3">
        Content provided by Minglee that is protected by intellectual property
        rights is owned by us. You are permitted to use our intellectual
        property as outlined in our Brand Usage Guidelines or with prior
        permission.
      </p>

      {/* Amendments and Termination */}
      <div className="text-2xl text-custom-red font-semibold my-8 mb-3">
        5. Amendments and Termination
      </div>
      <p className="pl-3">
        We may update these Terms to reflect changes to our services or for
        legal, regulatory, or security reasons. Notifications of changes will be
        communicated to you at least 30 days in advance. Continued use of
        Minglee after changes have taken effect implies your agreement to the
        updated terms.
      </p>

      {/* Liability and Dispute Resolution */}
      <div className="text-2xl text-custom-red font-semibold my-8 mb-3">
        6. Liability and Dispute Resolution
      </div>
      <p className="pl-3">
        Our services are provided "as is," and we disclaim all warranties to the
        extent permitted by applicable law. We limit our liability for damages
        as allowed by applicable law. For any disputes, the laws of your country
        of residence apply. Claims can be addressed in your local competent
        courts.
      </p>

      {/* Additional Sections */}
      <div className="flex items-center mt-5">
        <div className="w-1 bg-custom-red h-6 mr-3"></div>
        <div className="font-bold py-3">Data Transfer</div>
      </div>
      <p className="pl-3">
        To provide global services, we may transfer, store, and process your
        data in facilities globally.
      </p>
      <div className="flex items-center">
        <div className="w-1 bg-custom-red h-6 mr-3"></div>
        <div className="font-bold py-3">Community Standards and Policies</div>
      </div>
      <p className="pl-3">
        You are encouraged to familiarize yourself with our Community Standards,
        which govern the content and behavior on Minglee.
      </p>
      <div className="flex items-center">
        <div className="w-1 bg-custom-red h-6 mr-3"></div>
        <div className="font-bold py-3">Contact and Feedback</div>
      </div>
      <p className="pl-3">
        We welcome your feedback about our services. Feedback may be used to
        enhance our services without any obligation to compensate you.
      </p>
      <p className="pl-3">
        These Terms constitute the entire agreement between you and Minglee
        Platforms, Inc. regarding your use of our services. They supersede any
        prior agreements.
      </p>
    </div>
  );
};

export default TermsService;
